import '@fontsource-variable/roboto-condensed';
import $ from 'jquery';
import LangSelector from './components/lang-selector';
import NewsletterForm from './components/newsletter-form';
import ScrollInView from './components/scroll-in-view';
import SiteHeader from './components/site-header';

import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import { AccordionDef } from './components/accordion';
import { addPrevNextBtnsClickHandlers } from './components/emblaCarouselArrowButton';
import { setupProgressBar } from './components/emblaCarouselProgressBar';
import homeSlider from './components/homeSlider';
import { Lightbox } from './components/lightbox';
import Parallax from './components/parallax';
import DeviceManager from './utils/device-manager';

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $('html');

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass('touch');

      if (DeviceManager.isIos()) {
        $html.addClass('ios');
      }
    } else {
      $html.addClass('no-touch');
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass('ie11');
    } else if (DeviceManager.isEdge()) {
      $html.addClass('edge');
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($('.language-selector'));
    const siteHeader = new SiteHeader($('.site-header'), 20);

    // Home slider component

    // Newsletter form component
    const $newsletterFormElements = $('.footer-block.footer-block--newsletter-style');
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Scroll in view component
    const $scrollInViewElements = $('.scroll-in-view');
    if ($scrollInViewElements.length) {
      const scrollInView = new ScrollInView($scrollInViewElements);
    }
  };

  bootstrapApp();
  instanciateComponents();
});

const menuToggler = document.querySelector('.menu-toggler');

if (menuToggler) {
  const headerNavWrapper = document.querySelector('.header__nav-wrapper');
  const infoBanner = document.querySelector('.info-banner');
  menuToggler.addEventListener('click', () => {
    menuToggler.classList.toggle('menu-toggler--opened');
    headerNavWrapper.classList.toggle('menu--opened');
    infoBanner.classList.toggle('info-banner--closed');
  });
}

const loadingScreen = document.querySelector('.loading-screen');

if (loadingScreen) {
  document.querySelector('.loading-screen__text').addEventListener('click', () => {
    loadingScreen.remove();
  });
  setTimeout(() => {
    loadingScreen.remove();
  }, 5000);
}

const closeBanner = document.querySelector('#close-banner');
const infoBanner = document.querySelector('.info-banner');

if (closeBanner && infoBanner) {
  if (sessionStorage.getItem('infoBanner') === 'seen') {
    infoBanner.remove();
  } else {
    infoBanner.style.display = 'flex';
    setTimeout(() => {
      sessionStorage.setItem('infoBanner', 'seen');
    }, 800);
  }
  closeBanner.addEventListener('click', (e) => {
    e.preventDefault();
    infoBanner.remove();
  });
}

const accordions = document.querySelectorAll('.accordion');

if (accordions.length) {
  accordions.forEach((accordion) => {
    new AccordionDef(accordion);
  });
}

const cards = document.querySelectorAll('.card');

if (cards.length) {
  cards.forEach((card) => {
    const textWrapper = card.querySelector('.text-wrapper');
    const heading = card.querySelector('.heading');
    const text = card.querySelector('.text');

    if (textWrapper && heading && text) {
      const headingHeight = heading.offsetHeight;
      const textWrapperHeight = textWrapper.offsetHeight;

      textWrapper.style.bottom = `calc(-${textWrapperHeight}px + ${headingHeight}px + 16px * 2)`;
    }
  });
}

Parallax.bind();

const emblaNode = document.querySelector('.gallery');

if (emblaNode) {
  const OPTIONS = { align: 'start', loop: true };
  const viewportNode = emblaNode.querySelector('.embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
  const nextBtnNode = emblaNode.querySelector('.embla__button--next');
  const progressNode = emblaNode.querySelector('.embla__progress__bar');

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()]);

  const onNavButtonClick = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop;

    resetOrStop();
  };

  const { applyProgress, removeProgress } = setupProgressBar(emblaApi, progressNode);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode,
    onNavButtonClick
  );

  emblaApi
    .on('init', applyProgress)
    .on('reInit', applyProgress)
    .on('scroll', applyProgress)
    .on('slideFocus', applyProgress)
    .on('destroy', removeProgress)
    .on('destroy', removePrevNextBtnsClickHandlers);
}

const galleryLightboxSections = document.querySelectorAll('.gallery-section');

if (galleryLightboxSections.length > 0) {
  galleryLightboxSections.forEach((section) => {
    const galleryContainer = section.querySelector('.lightbox-container');

    if (galleryContainer) {
      Lightbox.init(galleryContainer);
    }
  });
}

const facebook = document.querySelectorAll('.face');

if (facebook.length > 0) {
  for (const face of facebook) {
    const content = face.querySelector('.face-content');
    const link = face.querySelector('a');
    content.style.transform = `translateY(calc(${link.offsetHeight}px + 8px))`;
  }
}

const toggleSearch = document.querySelector('.toggle-search');
const searchContainer = document.querySelector('.search-box__container');

if (toggleSearch && searchContainer) {
  toggleSearch.addEventListener('click', () => {
    let bannerHeight = 0;
    const infoBanner = document.querySelector('.info-banner');
    const header = document.querySelector('.header');
    searchContainer.classList.toggle('active');
    if (infoBanner) {
      searchContainer.style.top = `calc((${infoBanner.offsetHeight}px + 0.4rem * 2) + (${header.offsetHeight}px + 1.6rem * 2))`;
    } else {
      searchContainer.style.top = `calc((${header.offsetHeight}px + 1.6rem * 2))`;
    }
  });

  const closeSearch = searchContainer.querySelector('.close-container');
  if (closeSearch) {
    closeSearch.addEventListener('click', () => {
      searchContainer.classList.remove('active');
    });
  }
}

const productionsList = document.querySelector('.productions-list');
const eventsList = document.querySelector('.events-list');

if (productionsList) {
  homeSlider(productionsList);
}

if (eventsList) {
  homeSlider(eventsList);
}

const footerLabel = document.querySelector('label[for="input_1_3_1"]');

if (footerLabel) {
  const link = document.createElement('a');
  link.href = `${window.location.origin}/mentions-legales`;
  link.textContent = ', en savoir +';

  footerLabel.appendChild(link);
}
